import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavBar from '../../../_components/common/Navbar';
import Footer from '../../../_components/common/Footer';
import CustomTableNew from '../../../_components/common/CustomTableNew';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, CustomInput } from 'reactstrap';
import { userRelationGroup, } from '../../../_actions';
import { RoleFitmentReportAction } from '../../../_actions/organisations/roleFitmentReport/roleFitmentReport.action';
import { CommonBreadCrumb } from '../../../_components/common/CommonBreadCrumb';
import { LoaderComp } from '../../../_components/common/LoaderComp/Loadercomp';
import Page404 from '../../404page';
import { Link } from 'react-router-dom';





class ViewReport extends Component {
    constructor(props) {
        super(props);
    }
    state = {
        dropdownOpen: false,
        dropdownOpen2: false,
        hasProperId: true,
        idLoader: true,
        showRoleData: false,
        holders: [],
        selectedHolder: 0,
        selectedFitment: 0,
        roleFitmentType: null
    }

    componentDidMount() {
        let hasId = false
        if (this.props.location.state) {
            hasId = true
            if (this.props.location.state.dbData.respondents !== undefined) {
                this.props.location.state.dbData.respondents.map(val => {

                    if (val.respondent__full_name === null) {
                        val.respondent__full_name = val.respondent__email
                    }
                })
            }
            const data = {
                'user_assessment': this.props.location.state.dbData.id,
                'user': this.props.location.state.dbData.participant__id,
                'screen_type': 'dashboard'
            }
            this.props.dispatch(userRelationGroup.userRelationGroupHandler(data))
        } else {
            hasId = false
        }

        this.setState({
            hasProperId: hasId,
            idLoader: false
        })
    }

    toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    toggle2 = () => {
        this.setState({
            dropdownOpen2: !this.state.dropdownOpen2
        });
    }

    changeHolder = (selectedHolder) => {
        this.setState({
            selectedHolder
        })
    }

    changeFitment = (selectedFitment) => {
        this.setState({
            selectedFitment
        })
    }

    renderAssessment() {

        const {
            selectedHolder,
            selectedFitment
        } = this.state;

        const currentHolder = this.state.holders.find(item => item.id === selectedHolder)

        return (
            <div className="container custom-container my-5" >
                <CommonBreadCrumb
                    data={[
                        {
                            link: '/app/dashboard',
                            name: 'DASHBOARD'
                        },
                        {
                            link: '',
                            name: 'VIEW REPORT'
                        }
                    ]}
                />
                {
                    this.props.location.state !== undefined ?
                        <div>
                            <div className="d-flex flex-row flex-wrap justify-content-center align-items-center" style={{ borderStyle: 'solid', borderBottomWidth: 1, borderTopWidth: 0, borderRightWidth: 0, borderLeftWidth: 0 }}>
                                <div className=" col-md-2 col-8 ">

                                    <div className="d-flex flex-column ">
                                        <img className="img-fluid" src={localStorage.getItem('baseLink') + `/media/` + this.props.location.state.dbData.instrument__instrument_image} />
                                        <div className="progressTab d-flex flex-row justify-content-center  mx-auto col-8 col-md-12 mb-2">
                                            <div className={"  progressTabGreen"} >
                                            </div>
                                            <div className={" progressTabGreen"} >
                                            </div>
                                            <div className={" progressTabGreen"} >
                                            </div>
                                            <i className=" pl-1 pb-1  fas fa-check"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-">
                                    <div>
                                        <h2 className={"text-uppercase"}>{this.props.location.state.dbData.instrument__instrument_name} ASSESSMENT</h2>
                                        <p className="text-muted text-uppercase" style={{ fontSize: '18px' }}>{this.props.location.state.dbData.participant__full_name}'s {this.props.location.state.dbData.instrument__instrument_name}</p>
                                    </div>
                                </div>
                            </div>
                            <div>

                                {
                                    this.props.location.state.dbData.instrument__is_multi_rater !== false &&
                                        ((this.props.userRelationGroupLoading === false && this.props.userRelationGroupResponse.relation_list.length === 0) &&
                                            (this.props.userRelationGroupLoading === false && this.props.userRelationGroupResponse.dev_plan_list.length === 0)) ?
                                        <div className="p-4">
                                            <h4 style={{ color: '#888', textAlign: 'center' }}>No reports available at the moment</h4>
                                            <div className="text-center m-4">
                                                <Link to="/app/dashBoard">
                                                    <a className="btn btn-red text-white">BACK TO DASHBOARD</a>
                                                </Link>
                                            </div>
                                        </div>
                                        :
                                        <div>
                                            <p className="text-center">Your reports are ready!</p>
                                            <div className="d-flex flex-row justify-content-center">
                                                <div className="  col- mt-4 mx-2">
                                                    {
                                                        this.state.showRoleData ?
                                                            <div>
                                                                <p style={{ fontSize: "24px", textAlign: "center" }}>Role fitment report</p>
                                                                <div style={{ display: "flex" }}>
                                                                    <div style={{
                                                                        padding: "1rem",
                                                                        border: "1px solid #eee",
                                                                        minWidth: 180
                                                                    }}>
                                                                        <p>Category</p>
                                                                        <div>
                                                                            {
                                                                                this.state.holders.map(item => {
                                                                                    return (
                                                                                        <CustomInput
                                                                                            style={{ margin: "0.6rem 0" }}
                                                                                            onChange={() => this.changeHolder(item.id)}
                                                                                            type="radio"
                                                                                            name="holderRadio"
                                                                                            id={item.holder_name}
                                                                                            label={item.holder_name}
                                                                                        />
                                                                                    )
                                                                                })
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div style={{
                                                                        padding: "1rem",
                                                                        border: "1px solid #eee",
                                                                        minWidth: 180
                                                                    }}>
                                                                        <p>Reports</p>
                                                                        <div>
                                                                            {
                                                                                currentHolder ?
                                                                                    currentHolder.fitments.map(item => {
                                                                                        return (
                                                                                            <CustomInput
                                                                                                style={{ margin: "0.6rem 0" }}
                                                                                                onChange={() => this.changeFitment(item.id)}
                                                                                                type="radio"
                                                                                                name="fitmentRadio"
                                                                                                id={item.name}
                                                                                                label={item.name}
                                                                                            />
                                                                                        )
                                                                                    })
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <Link onClick={(e) => {
                                                                    if (!selectedHolder || !selectedFitment) {
                                                                        e.preventDefault();
                                                                    } else {
                                                                        localStorage.removeItem('download-obj');
                                                                        localStorage.setItem('download-obj', JSON.stringify({
                                                                            key: this.state.roleFitmentType,
                                                                            data: {
                                                                                'user_assessment_ids': [this.props.location.state.dbData.id],
                                                                                'holder_id': selectedHolder,
                                                                                'fitment_id': selectedFitment,
                                                                                'org_id': this.props.location.state.dbData.organisation
                                                                            }
                                                                        }))
                                                                    }
                                                                }} disabled={!selectedHolder || !selectedFitment}
                                                                    className="btn buttonColor"
                                                                    style={{
                                                                        color: 'white',
                                                                        borderColor: 'red',
                                                                        opacity: (!selectedFitment || !selectedHolder) ? 0.4 : 1,
                                                                        marginTop: "10px"
                                                                    }}
                                                                    to={{ pathname: `${this.props.location.pathname}/Download` }} target="_blank" >Download</Link>
                                                                <Button
                                                                    style={{ marginTop: 10, float: "right" }}
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            holders: [],
                                                                            selectedFitment: 0,
                                                                            selectedHolder: 0,
                                                                            showRoleData: false,
                                                                            roleFitmentType: null
                                                                        })
                                                                    }}>Back</Button>
                                                            </div>
                                                            :

                                                            this.props.location.state.dbData.instrument__is_multi_rater === false ?
                                                                this.props.location.state.dbData.instrument__instrument_name === 'VVI' ?
                                                                    <Link
                                                                        onClick={
                                                                            () => {
                                                                                localStorage.removeItem('download-obj');
                                                                                localStorage.setItem('download-obj', JSON.stringify({
                                                                                    key: this.props.location.state.dbData.instrument__instrument_name,
                                                                                    data: {
                                                                                        data: this.props.userRelationGroupResponse,
                                                                                        'user_assessment': this.props.location.state.dbData.id,
                                                                                        'user': this.props.location.state.dbData.participant__id
                                                                                    }
                                                                                }))
                                                                            }
                                                                        }
                                                                        className="btn buttonColor"
                                                                        style={{ color: 'white', borderColor: 'red' }}
                                                                        to={{ pathname: `${this.props.location.pathname}/Download` }} target="_blank" >
                                                                        Download Report
                                                                    </Link>
                                                                    :
                                                                    <UncontrolledDropdown>

                                                                        <DropdownToggle caret className="buttonColor" style={{ borderColor: 'red' }}>
                                                                            Download Report
                                                                        </DropdownToggle>
                                                                        <DropdownMenu>
                                                                            <DropdownItem>
                                                                                <Link
                                                                                    onClick={
                                                                                        () => {

                                                                                            localStorage.removeItem('download-obj');
                                                                                            localStorage.setItem('download-obj', JSON.stringify({
                                                                                                key: 'self',
                                                                                                screen_type: "assessment_summary",
                                                                                                data: {
                                                                                                    data: this.props.userRelationGroupResponse,
                                                                                                    'user_assessment': this.props.location.state.dbData.id,
                                                                                                    'user': this.props.location.state.dbData.participant__id
                                                                                                }
                                                                                            }))
                                                                                        }
                                                                                    }
                                                                                    to={{ pathname: `${this.props.location.pathname}/Download` }} target="_blank" >
                                                                                    Self Report
                                                                                </Link>
                                                                            </DropdownItem>
                                                                            <DropdownItem>
                                                                                <Button
                                                                                    style={{ background: "#fff", color: "#007bff", textAlign: "left", border: "none", padding: 0 }}
                                                                                    onClick={
                                                                                        () => {
                                                                                            this.props.dispatch(RoleFitmentReportAction.getAllotedOrganisationFitmentsAction({ orgId: this.props.userRelationGroupResponse.organisation }, (holders) => {
                                                                                                this.setState({
                                                                                                    holders: holders.data.holders,
                                                                                                    showRoleData: true,
                                                                                                    roleFitmentType: "ROLE_FITMENT"
                                                                                                })
                                                                                            }))
                                                                                        }
                                                                                    }
                                                                                    to={{ pathname: `${this.props.location.pathname}/Download` }} target="_blank" >
                                                                                    Role fitment report
                                                                                </Button>
                                                                            </DropdownItem>
                                                                        </DropdownMenu>
                                                                    </UncontrolledDropdown>
                                                                :
                                                                this.props.userRelationGroupLoading === false ?
                                                                    this.props.userRelationGroupResponse.relation_list.length !== 0 &&
                                                                    <UncontrolledDropdown>
                                                                        <DropdownToggle caret className="buttonColor" style={{ borderColor: 'red' }}>
                                                                            Download Report
                                                                        </DropdownToggle>
                                                                        <DropdownMenu>
                                                                            {
                                                                                this.props.userRelationGroupResponse.relation_list.map(
                                                                                    (data, i) => {
                                                                                        return <DropdownItem key={i} >
                                                                                            {
                                                                                                data.relation_group_id === 32 ?
                                                                                                    <div style={{ color: "#007bff", cursor: 'pointer' }} onClick={() => {
                                                                                                        this.props.dispatch(RoleFitmentReportAction.getAllotedOrganisationFitmentsAction({ orgId: this.props.userRelationGroupResponse.organisation }, (holders) => {
                                                                                                            this.setState({
                                                                                                                holders: holders.data.holders,
                                                                                                                showRoleData: true,
                                                                                                                roleFitmentType: "ROLE_FITMENT_LOI"
                                                                                                            })
                                                                                                        }))
                                                                                                    }}>
                                                                                                        {data.relation_group_name}
                                                                                                    </div>
                                                                                                    :
                                                                                                    <Link
                                                                                                        onClick={
                                                                                                            () => {
                                                                                                                localStorage.removeItem('download-obj');
                                                                                                                localStorage.setItem('download-obj', JSON.stringify({
                                                                                                                    key: 'report',
                                                                                                                    data: {
                                                                                                                        data,
                                                                                                                        'user_assessment': this.props.location.state.dbData.id,
                                                                                                                        'user': this.props.location.state.dbData.participant__id
                                                                                                                    },
                                                                                                                    screen_type: ""
                                                                                                                }))
                                                                                                            }
                                                                                                        }
                                                                                                        to={{ pathname: `${this.props.location.pathname}/Download` }} target="_blank" >{data.relation_group_name}</Link>
                                                                                            }
                                                                                        </DropdownItem>
                                                                                    }
                                                                                )
                                                                            }

                                                                        </DropdownMenu>
                                                                    </UncontrolledDropdown>
                                                                    :
                                                                    ''

                                                    }
                                                    {

                                                    }

                                                </div>
                                                {
                                                    this.props.userRelationGroupLoading === false
                                                }
                                                {
                                                    this.state.showRoleData === false &&
                                                    this.props.userRelationGroupLoading === false &&
                                                    this.props.userRelationGroupResponse.dev_plan_list &&
                                                    this.props.userRelationGroupResponse.dev_plan_list.length !== 0 &&
                                                    <div className=" col- mt-4 mx-2">
                                                        <UncontrolledDropdown>
                                                            <DropdownToggle caret className="buttonColor" style={{ borderColor: 'red' }}>
                                                                Development Plan
                                                            </DropdownToggle>
                                                            <DropdownMenu>
                                                                {
                                                                    this.props.userRelationGroupResponse.dev_plan_list.map(
                                                                        (data, i) => {
                                                                            return <DropdownItem>
                                                                                <Link
                                                                                    onClick={
                                                                                        () => {
                                                                                            localStorage.removeItem('download-obj');
                                                                                            localStorage.setItem('download-obj', JSON.stringify({
                                                                                                key: 'plan',
                                                                                                data: {
                                                                                                    data: data,
                                                                                                    'user_assessment': this.props.location.state.dbData.id,
                                                                                                    'user': this.props.location.state.dbData.participant__id
                                                                                                }
                                                                                            }))
                                                                                        }
                                                                                    }
                                                                                    to={{ pathname: `${this.props.location.pathname}/Download` }} target="_blank" >
                                                                                    {this.props.userRelationGroupLoading === false ? data.development_plan_name : ''}
                                                                                </Link>
                                                                            </DropdownItem>
                                                                        }
                                                                    )
                                                                }

                                                            </DropdownMenu>
                                                        </UncontrolledDropdown>

                                                    </div>
                                                }

                                            </div>
                                        </div>
                                }

                            </div>
                            {
                                this.props.location.state.dbData.instrument__is_multi_rater === true &&
                                <div className="pt-4">
                                    <div className="bg-green rounded-top">
                                        <h6 className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">RESPONDENT SUMMARY </h6>


                                    </div>
                                    <CustomTableNew
                                        data={this.props.location.state.dbData.respondents !== '' && this.props.location.state.dbData.respondents !== undefined ? this.props.location.state.dbData.respondents : []}
                                        columns={[{
                                            name: 'RESPONDENT',
                                            key: 'respondent__full_name',
                                            linkActive: false,
                                            link: '',
                                        },
                                        {
                                            name: 'RELATION',
                                            key: 'assessor_group__assessor_name',
                                            linkActive: false,
                                            link: '',
                                        },
                                        {
                                            name: 'STATUS',
                                            key: 'assessment_status__status_name',
                                            type: 'progressBubble',
                                            linkActive: false,
                                            link: '',
                                        }]}
                                        showSlNo="false"
                                        noPointerClass={true}

                                    />
                                </div>
                            }

                        </div>
                        :
                        null
                }
            </div >
        )
    }

    render() {


        if (!this.props.error) {
            return (
                <div>
                    <NavBar />
                    {
                        this.state.idLoader ?
                            <div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
                                <LoaderComp color={'black'} />
                            </div>
                            :
                            this.state.hasProperId ?
                                this.renderAssessment()
                                :
                                <Page404 unauthorised={true} />
                    }
                    <Footer />
                </div>
            );
        } else {
            return (
                // add swal
                <h1>Something went wrong</h1>
            );
        }

    }

}

function mapStateToProps(state) {



    const { userRelationGroupLoading } = state.userRelationGroupReducer;
    const userRelationGroupError = state.userRelationGroupReducer.error;
    const userRelationGroupResponse = (!userRelationGroupLoading) ? state.userRelationGroupReducer.data.data.data : '';


    return {
        userRelationGroupLoading,
        userRelationGroupResponse
    };
}

export default connect(mapStateToProps)(ViewReport);


// WEBPACK FOOTER //
// ./src/_pages/DashBoard/viewReport/viewReport.js